import { types as t, Instance } from 'mobx-state-tree';
import BaseConfiguration from './base';
import { ReportAirQualityStandardsTypes } from '../types';

const AqReportModel = t.compose(
  t.model({
    node_ids: t.array(t.string),
    parameters: t.array(t.frozen()),
    view: t.maybeNull(t.optional(t.enumeration('View', ['basic', 'extended']), 'basic')),
    standard: t.maybeNull(t.optional(t.string, ReportAirQualityStandardsTypes.airthinx_default))
  }),
  BaseConfiguration
);

export interface IReportConfigurationModel extends Instance<typeof AqReportModel> {}

export default AqReportModel;
